export const uk = {
    'select-empty': 'Незаполненные поля'
};
